module.exports = "/images/footer_logo.png?ec0d851a6e4dbbc448a424d1b3345492";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/images/footer_logo.png
// module id = pIJq
// module chunks = 0